import { render } from "./KpiList.vue?vue&type=template&id=1858a74e&scoped=true"
import script from "./KpiList.vue?vue&type=script&lang=js"
export * from "./KpiList.vue?vue&type=script&lang=js"

import "./KpiList.vue?vue&type=style&index=0&id=1858a74e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1858a74e"]])

export default __exports__